import { isPlatform } from '@ionic/react';
import { ContentStack } from '../models/home/contentStack.model';
import { ContentStackWeb } from '../models/home/homeContentStack.model';
import { logEvent } from './Analytics';
import { IONICWrapper } from './common';
import {Roles } from './constants';
import { EVENT, SCREEN } from './constants.analytics';
import { setCrashMessage, setUserId } from './Crashlytics';
import { offlineDataPerUserStart } from './OffNetwork.util';
import { usePushNotification } from './usePushNotification';

const { registerPush } = usePushNotification();
/**
 * if the props.userDetails changes call content stack API and log event
 * and it will get offline related data
*/
export const getDetailsByUser = (props: any, isRegistered: boolean) => {
  try {
    if (props?.userDetails && Object.keys(props.userDetails)?.length) {
      setUserId(props.userDetails?.memberDetailsResponse?.member?.upn);
      // Analytics implementation
      logEvent(
        IONICWrapper?.details?.auth?.user?.roles.includes(Roles.carrierGuest) ? EVENT.UE_GUEST_LOGIN_SUCCESS : EVENT.UE_LOGIN_SUCCESS,
        {
          screen: SCREEN.GET_STARTED,

        });
      const contentModel: ContentStack = new ContentStack();
      const contentWebModel: ContentStackWeb = new ContentStackWeb();
      if (!props.isContentStackApiCalled && isRegistered) {
        if (isPlatform("desktop") || isPlatform("mobileweb")) {
          props.getMoreTabContent(contentWebModel.getRequestPayloadWeb());
          props.getMoreTabContent(
            contentModel.getRequestPayload()
          );
        } else {
          props.getMoreTabContent(
            contentModel.getRequestPayload(props.getOfflineData.contentParams)
          );
        }
        props.setContentStackApiCalled(true);
        offlineDataPerUserStart(props);
      }
    }

  } catch (error) {
    console.error('ERROR:', error);
    setCrashMessage(`App UseEffect Error : ${error}`);
  }
}
/**
 * return user role from props
*/
export const getUserRole = (props: any) => {
  const role =
  props.userDetails && props.userDetails.memberDetailsResponse &&
  props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.userApplicationDetails &&
    props.userDetails.memberDetailsResponse.member.userApplicationDetails[0] &&
    props.userDetails.memberDetailsResponse.member.userApplicationDetails[0].roles &&
    props.userDetails.memberDetailsResponse.member.userApplicationDetails[0].roles[0] &&
    props.userDetails.memberDetailsResponse.member.userApplicationDetails[0].roles[0].roleName;
  return role || '';
}
export const checkUserHasData =(props:any)=>{
return (!(props.userDetails && props.userDetails.memberDetailsResponse &&
  props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.mobileNumber) || !(props.userDetails && props.userDetails.memberDetailsResponse &&
    props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.firstName) || !(props.userDetails && props.userDetails.memberDetailsResponse &&
      props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.lastName));
}
/**
 * if the props.userDetails changes it will check wether user is registered or not 
 * and if a registered user's (not guest) mobile number is not present 
 * then user will naviagte to edit profile page
*/
export const isUserRegistered = (props: any, setRegistered: any, push: any, isCapacitor: boolean) => {
  const roles = props.userDetails?.memberDetailsResponse?.member?.userApplicationDetails[0]?.roles.map((item :any) => item.roleName)
  const isMobile = (isPlatform('capacitor') || isPlatform('hybrid') || isPlatform('mobile'));
  if (props?.userDetails && Object.keys(props.userDetails).length) {
    const role = getUserRole(props);
    const hasData = (!(props.userDetails?.memberDetailsResponse?.member?.mobileNumber) || 
    !(props.userDetails?.memberDetailsResponse?.member?.firstName) || 
    !(props.userDetails?.memberDetailsResponse?.member?.lastName))
    if (role && role === Roles.carrierGuest && hasData) {
      setRegistered(false);
    } else {
      setRegistered(true);
      mobileCheckHandler(role, isMobile, push, hasData, props, roles);
    }
    capacitorCheckHandler(isCapacitor,props);
  }
}

function capacitorCheckHandler(isCapacitor: boolean, props: any) {
  if (isCapacitor) {
    registerPush(props.userDetails);
  }
}

function mobileCheckHandler(role: any, isMobile: boolean, push: any, hasData: boolean, props: any, roles: any) {
  if (role && role !== Roles.carrierGuest && hasData) {
    isMobile ? push('/app/manage/ProfileDetails/edit') : push('/app/userProfile/edit', {
      isEdit: true,
      selectedUser: { ...props.userDetails, roles },
      isSelf: true
    });
  }
}